import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Checkbox } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ franchiseeId, error, handleSubmit, pristine, submitting, submitSucceeded, isReadonly, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='city' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Territory_City')} validate={validators.required} />
			<Field name='name' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Territory_Name')} validate={validators.required} />
			<Field name='description' component={Input} disabled={isReadonly} horizontal componentClass='textarea' label={t('Territory_Description')} />
			<Field name='isOnline' component={Checkbox} disabled={isReadonly} horizontal label={t('Territory_IsOnline')} normalize={v => !!v} />
			<FormActions horizontal>
				<Link to={`/franchisees/${franchiseeId}/territories`} className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'territory', enableReinitialize: true })(withTranslation()(SettingsForm));
